import { ValidationService } from 'aspnet-client-validation';

export class CustomValidationService {
    private validationService: ValidationService;

    constructor() {
        this.validationService = new ValidationService();
    }

    public initialize(): void {
        this.validationService.bootstrap();
        this.setupCustomProviders();
    }

    private setupCustomProviders(): void {
        this.setupMinimumAgeProvider();
        this.setupRequiredIfProvider();
    }

    private setupMinimumAgeProvider(): void {
        this.validationService.addProvider('minimumage', (value, _element, params) => {
            let date = new Date(value);
            let today = new Date();

            let minimumAge = parseInt(params['age']) ?? 18;
            let age = today.getFullYear() - date.getFullYear();
            let monthDiff = today.getMonth() - date.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
                age--;
            }

            return age >= minimumAge;
        });
    }

    private setupRequiredIfProvider(): void {
        this.validationService.addProvider('requiredif', (value, element, params) => {
            var targetId = params.otherproperty;
            var targetValue = params.otherpropertyvalue;

            var otherPropertyValue = (targetValue == null || targetValue == undefined ? "" : targetValue).toString();

            // Scoped to the field's own form, not the whole document: an id like this could collide with
            // an identically-named field in another form on the same page (see the donation popup id
            // collision fixed in native-validation-service.ts for a case where that actually happened).
            var scope = element.form ?? document;
            var otherPropertyElement = scope.querySelector('#' + targetId) as HTMLInputElement;

            if (!otherPropertyElement) {
                return true;
            }

            // Checkboxes/radios (e.g. SameAsAbove) carry their answer in `.checked`, not `.value` (a
            // checkbox's `value` attribute is a fixed string regardless of ticked state). Every other
            // element type — including a hidden field like IsJuniorMembership, which has no `checked`
            // state at all — carries its answer in `.value`.
            var isCheckboxOrRadio = otherPropertyElement.type === 'checkbox' || otherPropertyElement.type === 'radio';
            var actualValue = isCheckboxOrRadio ? otherPropertyElement.checked.toString() : otherPropertyElement.value;

            if (actualValue.toLowerCase() === otherPropertyValue.toLowerCase()) {
                return value !== '';
            }

            return true;
        });
    }
}
